const translations = {
    captionText: 'Tap here to Add a New Client, Vehicle, Proposal, etc.'
};

export default translations;
